<template>
  <v-container fluid>
    <avs-backButton backTo="Inspections" />
    <avs-card noTitle>
      <template v-slot:content>
        <v-col>
          <v-card-text>
            <InspectionForm
              :validate-counter="validateRequest"
              @validated="v => (isFormValid = v)"
              v-model="inspection"
            />
          </v-card-text>
        </v-col>
        <v-card-actions class="mr-4 justify-end">
          <avs-saveButton
            :disabled="isLoading"
            @click="save"
          />
        </v-card-actions>
      </template>
    </avs-card>
  </v-container>
</template>

<script>
import _ from "lodash"

import { InspectionForm } from "@/components"
import { InspectionService } from "@/services"
import { mkInspection } from "@/utils/datamodels"

export default {
  name: "InspectionCreateUpdate",
  components: {
    InspectionForm
  },
  data() {
    return {
      isLoading: false,
      validateRequest: 0,
      isFormValid: true,
      tab: 0,
      inspectionRef: null,
      inspection: mkInspection()
    }
  },
  methods: {
    save() {
      this.validateRequest++
      this.$nextTick(() => {
        if (this.isFormValid) {
          // Ajouter la langue actuelle à l'inspection
          this.inspection.lang = this.$i18n.locale
          if (this.id) this.updateInspection()
          else this.createInspection()
        } else {
          this.$store.commit("app/message", {
            msg: this.$t("messages.warning.all_required_info"),
            color: "warning"
          })
        }
      })
    },
    send(msg, color) {
      this.$store.commit("app/message", { msg, color })
    },
    getInspection(id) {
      InspectionService.get(this, null, id).then(r => {
        this.inspection = r
        this.inspectionRef = _.cloneDeep(this.inspection)
      })
    },
    createInspection() {
      this.isLoading = true
      InspectionService.create(this, this.$store.state.app.project.id, {
        ...this.inspection
        // attachments: filesToCreate
      })
        .then(() => {
          this.$store.commit("app/message", {
            msg: this.$t("messages.success.created", {
              entity: this.$tc("categories.inspection.name", 1)
            }),
            color: "success"
          })
          this.$router.push({ name: "Inspections" })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    updateInspection() {
      if (!_.isEqual(_.omit(this.inspection), _.omit(this.inspectionRef))) {
        this.isLoading = true
        InspectionService.update(
          this,
          this.inspection.id,
          _.pick(this.inspection, [
            "name",
            "start_date",
            "end_date",
            "status",
            "notify_oncreated",
            "notify_team_oncreated",
            "users",
            "lang",
            "attachments",
            "external_emails"
          ])
        )
          .then(() => {
            this.$store.commit("app/message", {
              msg: this.$t("messages.success.updated", {
                entity: this.$tc("categories.inspection.name", 1)
              }),
              color: "success"
            })
            this.$router.go(-1)
          })
          .finally(() => {
            this.isLoading = false
          })
      } else {
        this.send(this.$t("messages.success.no_updated"), "info")
        this.$router.go(-1)
      }
    }
  },
  created() {
    if (this.id) this.getInspection(this.id)
  },
  computed: {
    id() {
      return this.$route.params.id || null
    },
    title() {
      return this.id
        ? this.$t("actions.edit", {
            entity: this.$tc("categories.inspection.name", 1).toLowerCase()
          })
        : this.$t("actions.new_female", {
            entity: this.$tc("categories.inspection.name", 1).toLowerCase()
          })
    }
  }
}
</script>
